import { Action, createReducer, on } from '@ngrx/store';
import { initialContactInformationFieldsState } from './contact-information-fields.state';
import {
  clearContactInformationFields,
  initializeContactInformationFieldsState,
  saveContactInformationFieldsComplete,
} from './contact-information-fields.actions';

const featureReducer = createReducer(
  initialContactInformationFieldsState,
  on(initializeContactInformationFieldsState, (state) => ({ ...state, ...initialContactInformationFieldsState })),
  on(saveContactInformationFieldsComplete, (state, { response }) => ({ ...state, BulkReservationInformationResponse: response })),
  on(clearContactInformationFields, (state) => ({ ...state, BulkReservationInformationResponse: null }))
);

export function contactInformationFieldsReducer(state = initialContactInformationFieldsState, action: Action) {
  return featureReducer(state, action);
}
